import { Navigate, useLocation } from 'react-router';

/**
 * `/policies/explorer` → `/policies/simulator`, keeping the query string (and hash)
 * so a bookmarked or shared explorer link opens the same case in the Simulador.
 */
export function ExplorerRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={{ pathname: '/policies/simulator', search, hash }} replace />;
}
